import { Component, OnInit, OnDestroy, Input } from "@angular/core";
import { SharedModule, Dialog, DataService } from "@bb-vendure/admin-ui/core";
import { Observable, map } from "rxjs";
import { GuidanceByLocationIdQuery } from "../generated-gql/graphql";
import { GuidanceByLocationIdDocument } from "../generated-gql/graphql";
import { SafePipe } from "./safe-html.pipe";
@Component({
  selector: "guidance-component",
  standalone: true,
  imports: [SharedModule, SafePipe],
  template: `
    <div>
      <div *ngIf="guidance$ | async as guidance; else noContent">
        <div [innerHTML]="renderContent(guidance) | safe : 'html'"></div>
      </div>
      <ng-template #noContent>
        <h4>No Guidance available, please contact admin</h4>
      </ng-template>
    </div>
  `,
})
export class GuidanceComponent implements OnInit, OnDestroy, Dialog<any> {
  @Input() locationId: string;
  @Input() language: string;
  constructor(protected dataService: DataService) {}

  guidance$: Observable<GuidanceByLocationIdQuery["guidanceByLocationId"]>;

  ngOnInit(): void {
    this.guidance$ = this.dataService
      .query(GuidanceByLocationIdDocument, {
        locationId: this.locationId,
      })
      .single$.pipe(
        map((result) => {
          return result.guidanceByLocationId;
        })
      );
  }

  close() {
    this.resolveWith();
  }

  renderContent(guidance: GuidanceByLocationIdQuery["guidanceByLocationId"]) {
    const translation = guidance?.translations.find(
      (translation) => translation.languageCode === this.language
    );
    return (
      translation?.localizedContent ||
      guidance?.translations[0]?.localizedContent ||
      ""
    );
  }

  resolveWith: (result?: any) => void;
  ngOnDestroy(): void {}
}
